<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="insCompletedEe" :value="1" :disabled="disabled">
                    ¿Instalación completa EE?
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        insCompletedEe: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localInsCompletedEE: this.insCompletedEe,
        }
    },
    watch: {
        insCompletedEe(newVal) {
            this.localInsCompletedEE = newVal
            this.$emit('update', { ins_completed_ee: this.localInsCompletedEE })
        },
    },
}
</script>
